import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

import { postJwtLogin } from "../../../helpers/fakebackend_helper";
import { profileSuccess } from "../profile/actions";

function* loginUser({ payload: { user, history } }) {
  try {
    // const response = yield call(postJwtLogin, {
    //   email: user.email,
    //   password: user.password,
    // })
    // localStorage.setItem("user", JSON.stringify(response))
    yield put(loginSuccess(response))
    yield put(profileSuccess(response))
    // history.push("/dashboard")
  } catch (error) {
    yield put(apiError(error))
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser");
    history.push("/login");
  } catch (error) {
    yield put(apiError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
